import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import { getBackgroundImageUrl } from "../../../../helpers/navigationBackgroundImageResolver";
import LazyImage from "../../../LazyImage";

const cx = classnames.bind(styles);

const FlatItem = ({ className, item, saveNavigationItem }) => (
  <li className={cx(styles.container, className)}>
    <LazyImage
      href={item.link}
      data-navid={item.id}
      className={cx(styles.menuItem, styles.flatMenuItem)}
      ref={saveNavigationItem}
      data-testid="menu-item"
      src={getBackgroundImageUrl(item.smallAndMediumImageUrl, 320)}
      tag={"a"}
    >
      <p
        className={cx(styles.label, {
          [styles.label__light]: item.smallAndMediumStyleType === "light"
        })}
      >
        {item.label.substring(0, 24)}
      </p>
    </LazyImage>
  </li>
);

FlatItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.any,
  saveNavigationItem: PropTypes.func.isRequired
};

export default FlatItem;
